module.exports = __webpack_public_path__ + "img/trunOn_power.50394e82.svg";